import { Base } from '../base-component';

import './deals-list-filter-year.component.scss';

export class DealsListFilterYear extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}



// WEBPACK FOOTER //
// ./components/deals-list-filter-year/deals-list-filter-year.component.ts